import React from 'react';

import { Button, Flex, Heading } from '@rover/kibble/core';
import { BottomSheet } from '@rover/kibble/official-patterns/BottomSheet';
import TextWithSingleInlineLink from '@rover/kibble/official-patterns/TextWithSingleInlineLink';

import {
  META_DISCOUNT_AMOUNT,
  META_DISCOUNT_AMOUNT_LABEL,
  META_DISCOUNT_CURRENCY_SYMBOL,
  META_DISCOUNT_TERMS_URL,
} from './constants';
import CouponIllustration from './CouponIllustration';

type MetaDiscountSheetProps = {
  onCtaClick: () => void;
  onDismiss: () => void;
};

const MetaDiscountSheet = ({ onCtaClick, onDismiss }: MetaDiscountSheetProps): JSX.Element => (
  <BottomSheet
    isOpen
    closeOnDragDown
    onRequestClose={onDismiss}
    headerId="meta-discount-sheet-heading"
  >
    <Flex flexDirection="column" gap="4x" pb="4x">
      <Flex justifyContent="center">
        <CouponIllustration
          variant="hero"
          symbol={META_DISCOUNT_CURRENCY_SYMBOL}
          amount={META_DISCOUNT_AMOUNT}
        />
      </Flex>
      <Heading id="meta-discount-sheet-heading" size="300" mb="0x">
        {`Get ${META_DISCOUNT_AMOUNT_LABEL} off your first booking`}
      </Heading>
      <TextWithSingleInlineLink
        asParagraph
        size="200"
        mb="0x"
        href={META_DISCOUNT_TERMS_URL}
        target="_blank"
        paragraphText="Sign up now to save on your first pet care booking on Rover. <0>Terms apply.</0>"
      />
      <Button variant="primary" size="large" fullWidth onPress={onCtaClick}>
        {`Sign up to claim ${META_DISCOUNT_AMOUNT_LABEL}`}
      </Button>
    </Flex>
  </BottomSheet>
);

export default MetaDiscountSheet;
